<!-- 父组件示例 -->
<template>
  <div class="container">
    <el-button type="primary" @click="showDialog = true">列配置</el-button>

    <!-- 表格区域 -->
    <el-table :data="tableData" border style="width: 100%; margin-top: 20px">
      <template v-for="col in tableColumns">
        <el-table-column
          v-if="col.visible"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
        />
      </template>
    </el-table>

    <!-- 列配置组件 -->
    <column-configurator
      :visible.sync="showDialog"
      :columns.sync="tableColumns"
      @confirm="handleColumnsConfirm"
      @cancel="handleColumnsCancel"
    />
  </div>
</template>
  
  <script>
import ColumnConfigurator from "@/components/ColumnConfigurator";

export default {
  components: { ColumnConfigurator },
  data() {
    return {
      showDialog: false,
      // 完整的表格数据示例
      tableData: [
        {
          name: "张三",
          age: 25,
          gender: "男",
          address: "北京市",
          email: "zhangsan@example.com",
        },
        {
          name: "李四",
          age: 30,
          gender: "女",
          address: "上海市",
          email: "lisi@example.com",
        },
        // 更多数据...
      ],
      // 完整的列配置
      //   tableColumns: [
      //     { prop: "name", label: "姓名", visible: true, width: 120 },
      //     { prop: "age", label: "年龄", visible: true, width: 100 },
      //     { prop: "gender", label: "性别", visible: true, width: 100 },
      //     { prop: "address", label: "地址", visible: true, width: 200 },
      //     { prop: "email", label: "邮箱", visible: false, width: 250 },
      //   ],
      tableColumns: [
        {
          width: 25,
          relativeWidth: 1,
          title: "序号",
          field: "seq",
          checked: false,
          fixed: true,
          formatter2: "function f(a,b,i){ return i + 1 }",
          tableTextType: "sequence",
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 2,
          relativeWidth: 1,
          title: "商品名称",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '商品名称' }",
          field: "name",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "规格",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '规格' }",
          field: "specs",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "商品编号",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '商品编号' }",
          field: "code",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "条码",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '条码' }",
          field: "barcode",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "仓库",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '仓库' }",
          field: "storeName",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "数量",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '数量' }",
          field: "quantity",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "单位",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '单位' }",
          field: "unitName",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "单价",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '单价' }",
          field: "price",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "金额",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '金额' }",
          field: "totalPrice",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 2,
          relativeWidth: 1,
          title: "备注",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '备注' }",
          field: "remarks",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "属性",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '属性' }",
          field: "attrs",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "序列号",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '序列号' }",
          field: "serialCode",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "可用数量",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '可用数量' }",
          field: "availableQuantity",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "批号",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '批号' }",
          field: "batchNumber",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "生产日期",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '生产日期' }",
          field: "productionDate",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "自定义字段1",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '自定义字段1' }",
          field: "customField1",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "自定义字段2",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '自定义字段2' }",
          field: "customField2",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "自定义字段3",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '自定义字段3' }",
          field: "customField3",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "保质期天数",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '保质期天数' }",
          field: "shelfLifeDays",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "有效日期",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '有效日期' }",
          field: "effectiveDate",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "折前价格",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '折前价格' }",
          field: "priceDef",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "税率",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '税率' }",
          field: "taxRate",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "税额",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '税额' }",
          field: "taxAmount",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "生产厂家",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '生产厂家' }",
          field: "origin",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "注册证号",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '注册证号' }",
          field: "regNum",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
        {
          width: 1,
          relativeWidth: 1,
          title: "许可证",
          formatter2:
            "function f(value,b,i){ if(value) return value;return '许可证' }",
          field: "licenseNum",
          checked: false,
          fixed: false,
          rowspan: 1,
          colspan: 1,
        },
      ],
    };
  },
  methods: {
    handleColumnsConfirm(columns) {
      this.tableColumns = columns;
      // 这里可以添加持久化逻辑（如保存到localStorage）
    },
    handleColumnsCancel() {
      this.showDialog = false;
    },
  },
};
</script>